import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetManyCountResponse } from 'coreOld/types';

interface IState {
  companyPartsCount: GetManyCountResponse;
}

const initialState: IState = {
  companyPartsCount: null,
};

const companyPartsSlice = createSlice({
  name: 'companyPartsCount',
  initialState,
  reducers: {
    setCompanyPartsCount: (state, action: PayloadAction<GetManyCountResponse>) => {
      state.companyPartsCount = action.payload;
    },
  },
});

export const { setCompanyPartsCount } = companyPartsSlice.actions;

export const companyPartsReducer = companyPartsSlice.reducer;
